export const actionKey = '@@uploads';
export const MAX_FILE_SIZE = 1000000000;
